module.exports = __webpack_public_path__ + "img/flecha_bajo.16756a35.svg";